<div class="container-card-config col-md-10 col-md-offset-1" *ngIf="client">
  <div class="row">
    <div class="col-xs-12 card">
      <div class="row">
        <div class="col-xs-12">
          <h2>{{ client.Nome }}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label for="" class="control-label">CPF/CNPJ</label>
            <h5 class="mar-no">{{ maskCpfCnpj(client.CpfCnpj) }}</h5>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label for="" class="control-label">Telefone</label>
            <h5 class="mar-no">{{ client.Telefone }}</h5>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label for="" class="control-label">E-mail</label>
            <h5 class="mar-no">{{ client.Email }}</h5>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label for="" class="control-label">Data de Nascimento</label>
            <h5 *ngIf="client && client.DataNascimento" class="mar-no">{{ formatDate(client.DataNascimento) }}</h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label for="" class="control-label">Endereço</label>
            <h5 class="mar-no">{{ client.Logradouro }}, {{ client.EnderecoNumero }}, {{ client.EnderecoComplemento }}, {{ client.Bairro }} - {{ client.Cidade }} - {{ client.Estado }} - {{ client.Cep }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <ul class="menu-cliente">
        <li [ngClass]="tabNumber === 1 ? 'active' : ''" (click)="selectTab(1)">Vendas</li>
        <li [ngClass]="tabNumber === 2 ? 'active' : ''" (click)="selectTab(2)">Transações</li>
      </ul>
    </div>
  </div>

  <div class="row" *ngIf="tabNumber === 1">
    <div class="col-xs-12">
      <ul class="vendas">
        <!-- <li class="venda">
          <h2>
            <a>Musculação, Ergometria e Jiu Jitsu</a>
          </h2>
          <p>Recorrente<strong>&nbsp;&nbsp;·&nbsp;&nbsp;</strong><strong> 6 </strong>Parcelas</p>
          <p><strong><span class="primary bold">Ativa</span>&nbsp;&nbsp;·&nbsp;&nbsp;</strong>Próxima parcela em: <strong>25/10/2018</strong></p>
        </li>
        <li class="venda">
          <h2>
            <a>Crossfit, Natação e Hidromassagem</a>
          </h2>
          <p>Recorrente<strong>&nbsp;&nbsp;·&nbsp;&nbsp;</strong><strong> 12 </strong>Parcelas</p>
          <p><strong><span class="bold">Cancelada</span>&nbsp;&nbsp;·&nbsp;&nbsp;</strong>Próxima parcela em: <strong>25/10/2018</strong></p>
        </li> -->
        <li class="venda" *ngFor="let sale of sales">
          <h2><a>{{ sale.Descricao }}</a></h2>
          <p *ngIf="sale && sale.Parcelas">Parcelado<strong>&nbsp;&nbsp;·&nbsp;&nbsp;</strong><strong>{{ sale.Parcelas }}</strong> <span *ngIf="sale.Parcelas === 1">Parcela</span><span *ngIf="sale.Parcelas !== 1">Parcelas</span></p>
          <p *ngIf="sale && sale.Recorrencia">Recorrente<strong>&nbsp;&nbsp;·&nbsp;&nbsp;</strong><strong>{{ sale.Recorrencia.QuantidadeRecorrencia }}</strong> <span *ngIf="sale.Recorrencia.QuantidadeRecorrencia === 1">Parcela</span><span *ngIf="sale.Recorrencia.QuantidadeRecorrencia !== 1">Parcelas</span></p>
          <p><strong><span class="bold">{{ sale.Situacao }}</span></strong><strong *ngIf="sale && sale.Situacao !== 'Recebido'">&nbsp;&nbsp;·&nbsp;&nbsp;</strong><span *ngIf="sale && sale.Situacao !== 'Recebido'">Próxima parcela em: {{ getNextDate(sale) }}</span></p>
        </li>
      </ul>
    </div>
  </div>

  <div class="row" *ngIf="tabNumber === 2">
    <div class="col-xs-12">
      <ul class="vendas">
        <li class="venda" *ngFor="let transaction of transactions">
          <h2><a>{{ transaction.Descricao }}</a></h2>
          <p>{{ formatCurrency(transaction.Valor) }}<span *ngIf="transaction.DataRecebimento"><strong>&nbsp;&nbsp;·&nbsp;&nbsp;</strong>{{ formatDate(transaction.DataRecebimento) }}</span><span class="cartao"><span class="bandeira-cartao" [ngClass]="getCreditCardBrand(transaction.BandeiraCartao)"></span><span class="final-cartao">final {{ transaction.NumeroCartao }}</span></span></p>
          <p><strong><span [ngClass]="getTransactionStatus(transaction) === 'Aprovada' ? 'primary' : ''">{{ getTransactionStatus(transaction) }}</span></strong></p>
        </li>
      </ul>
    </div>
  </div>
</div>
